import ztComponent from './ztAlert.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
